<template>
    <div>
        <van-button type="primary" @click="setSession">存session</van-button>
        <van-button type="primary" @click="getSession">取session</van-button>
        <van-button type="primary" @click="tiao">跳页</van-button>
    </div>
</template>

<script>
export default {
    methods:{
        setSession(){
            sessionStorage.setItem('names','crt1')
        },
        tiao(){
            window.location.href='http://127.0.0.1:8848/sessions/index.html'
        },
        getSession(){
            let get = sessionStorage.names
            console.log(get)
        }
    }
}
</script>

<style scoped>

</style>